export const LABELS = {
  MENU_TITLE: 'Reanotar pacotes'
};

export default { LABELS };
